/**
 * API URL Configuration
 * Automatically uses relative URLs for custom domains to avoid CORS issues
 */

export const getApiUrl = () => {
  const hostname = window.location.hostname;
  
  // If on custom domain (not localhost, not preview), use relative URL
  if (hostname !== 'localhost' && !hostname.includes('preview.emergentagent.com')) {
    return '/api';
  }
  
  // Use environment variable for localhost and preview
  return `${process.env.REACT_APP_BACKEND_URL}/api`;
};

export const getBaseUrl = () => {
  const hostname = window.location.hostname;
  
  if (hostname !== 'localhost' && !hostname.includes('preview.emergentagent.com')) {
    return '';
  }
  
  return process.env.REACT_APP_BACKEND_URL || '';
};

// Export a constant for immediate use (evaluated at import time)
export const API = getApiUrl();
